// extracted by mini-css-extract-plugin
export var content = "_na-1";
export var fullScreen = "_na-0";